import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 { font-size: 22px; margin: 0; }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 720px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
`;

export const StatCard = styled.div<{ accent: string }>`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid ${({ accent }) => accent};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  strong { display: block; font-size: 26px; }
  span { color: #8c8c8c; font-size: 13px; }
`;

export const TicketCell = styled.div`
  .title { font-weight: 600; }
  .meta { color: #8c8c8c; font-size: 12px; }
`;

export const Badge = styled.span<{ color: string }>`
  background: ${({ color }) => color}22;
  color: ${({ color }) => color};
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  white-space: nowrap;
`;
